// ** React Imports
import { useState, useEffect } from 'react'
import axios from 'axios'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import React from 'react'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import Button from '@mui/material/Button'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import { Grid, Typography } from '@mui/material'
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteIcon from '@mui/icons-material/Delete'
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import "../Button.css"
import fileDownload from 'js-file-download';
import LoadingButton from '@mui/lab/LoadingButton'
import Download from '@mui/icons-material/Download'
import moment from 'moment';
import Swal from 'sweetalert2';
import ReactSelect from 'react-select';
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { confirmAlert } from 'react-confirm-alert' // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper'

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Backdrop } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useAlert } from "react-alert";
import Modal from '@mui/material/Modal';
import { Controller, useForm } from 'react-hook-form';
import Documents from '../Documents'
const Notification = (props) => {
  document.title = "Notification | LuxBilling";

  const getRowSpacing = React.useCallback(params => {
    return {
      top: params.isFirstVisible ? 0 : 0.5,
      bottom: params.isLastVisible ? 0 : 0.8
    }
  }, [])
  const [isLoading, setLoading] = useState(false)
  const token = localStorage.getItem('Token')
  const UserType = localStorage.getItem('User_Type')

  const auth = `Bearer ${token}`
  const headers = {
    Authorization: auth
  }


  const fields = [
    'id',
    'patientId',
    'roomName',
    'duration',
    'limit',
    'inactive',
    'practiceId',
    'createdDate',
    'createdBy',
    'updatedDate',
    'updatedBy',
    'clientCreatedDate',
    'clientUpdatedDate',
  ];

  const defValues = {
    id: 0,
    patientId: 0,
    roomName: '',
    duration: '',
    limit: '',
    practiceId: 0,
    createdDate: '',
    createdBy: '',
    updatedDate: '',
    updatedBy: '',
    clientCreatedDate: '',
    clientUpdatedDate: '',
  };

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    context: undefined,
    criteriaMode: 'firstError',
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    // resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });
  const patientid = props.PatientId
  const gridStyle = {
    color: '#8392ab !important',
    textTransform: 'lowercase',
    fontSize: '13.6px',
    fontWeight: '400',
    '&:hover': {
      color: 'rgba(5, 152, 236, 0.637) !important',
      fontSize: '14.6px'
    }
  }

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: 'drak',
    fontSize: '13.4px !important',
    color: 'drak !important',
    borderColor: '#326C1D',
    '& .MuiDataGrid-cell:hover': {
      color: 'rgba(5, 152, 236, 0.637) !important',
      fontSize: '14.6px !important',
    },
    '& .super-app-theme--header': {
      backgroundColor: '#377562',
      borderRadius: 0.1,
      color: 'white',
      fontSize: '16px !important',

    },

  }
  const gridClasses = {
    columnHeader: 'MuiDataGrid-columnHeaders',
  };
  const [value, setvalue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setvalue(newValue);
  };
  const [refresh, setRefresh] = useState(false)
  const navigate = useNavigate();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [Delbyid, setDelbyid] = useState(false);
  const [Patientiidresolve, setPatientiidresolve] = useState('');
  const [subject, setsubject] = useState('');
  const [assginedto, setassginedto] = useState('');
  const [date, setdate] = useState('');
  const [comments, setcomments] = useState('');

  const alert = useAlert();

  const handleDelete = (cell) => {
    // Perform your delete logic here
    const postData = {
      id: Delbyid,
      resolved: false,
      patientId: Patientiidresolve,
      subject: subject,
      assignedTo: assginedto,
      createdDate: date,
      comments: comments,

    };
    axios
      .post(`${process.env.REACT_APP_API_URL}/Notifications/AddNotifications`, postData, {
        headers,
      })
      .then((response) => {
        setRefresh(!refresh);
        console.log("aaa", response)
      })
      .catch((error) => {
        console.error('There was an error!', error);
      });
    // Close the dialog
    setDialogOpen(false);
  };
  const [patientName, setPatientName] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [patientId, setPatientId] = useState(null);
  const [ImageData, setImageData] = useState('')
  const handleRowClick2 = async (cellValues) => {
    setOpenModal(true);
    const Id = cellValues.row.id
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/Notifications/getNotificationsById?id=${cellValues.row.parentId > 0 ? cellValues.row.parentId : cellValues.row.id}`,
      { headers }
    );
    // const filteredData = response.filter(
    //   item => item.id === Id || item.parentId === Id
    // );
    setSelectedRow(response);


  };

  useEffect(() => {
    if (patientId) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/PatientDocument/notificationDocumentbyId?notificationId=${patientId}`, { headers })
        .then((response) => {
          setImageData(response);
        })
        .catch((error) => {
          console.error("Error fetching patient documents:", error);
        });
    }
  }, [patientId]);
  const [opendocs, setopendocs] = useState(false)
  const [DocName, setDocName] = useState('')
  const [urldownload, seturldownload] = useState('')
  const [urlFile, seturlFile] = useState('')
  const [FullDocName, setFullDocName] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const download = (url, filename) => {
    setSubmitting(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${url}`, {
        headers,
        responseType: 'blob'
      })
      .then(res => {
        setopendocs(false)
        setSubmitting(false)
        fileDownload(res, filename)
      })
      .catch(err => {
        setSubmitting(false)
      })
  }
  const styleofmodal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 950,
    bgcolor: 'background.paper',
    border: '2px solid #377562',
    boxShadow: 24,
    p: 4
  }
  const handleClose = () => {
    setopendocs(false);

  };
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.1
    },

    {
      field: 'patientName',
      headerName: 'Patient Name',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3,
      renderCell: (cellValues) => (
        <Button
          style={{ color: 'rgba(58, 53, 65, 0.87)', display: 'flex', justifyContent: 'flex-start' }}
          size="small"
          variant="text"
          color="info"
          onClick={() => handleRowClick2(cellValues)}
        // onClick={() => {
        //   handleRowClick(cellValues);
        //   setPatientId(cellValues.row.id); 
        // }}
        >
          {cellValues.row.patientName}
        </Button>
      ),
    },
    {
      field: 'createdDate',
      headerName: 'Created Date',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3,
      valueGetter: (params) => {
        return moment(params.row.createdDate).format('MM-DD-YYYY');
      }
    },
    {
      field: 'subject',
      headerName: 'Subject',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3
    },
    {
      field: 'comments',
      headerName: 'comments',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3
    },

    {
      field: 'assignedTo',
      headerName: 'From',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3
    },

    // {
    //   field: 'inactive',
    //   headerName: 'Delete',
    //   sortable: true,
    //   headerClassName: 'super-app-theme--header',
    //   minWidth: 50,
    //   renderCell: cell => (
    //     <DeleteIcon
    //       style={{
    //         marginRight: '5px',
    //         float: 'right',
    //         marginTop: '5px',
    //         color: 'red',
    //         cursor: 'pointer'
    //       }}
    //       onClick={cellValues => {
    //         // console.log('Cell: ', cell)
    //         confirmAlert({
    //           message: 'Do you want to delete the record.',
    //           closeOnEscape: true,
    //           closeOnClickOutside: true,
    //           overlayClassName: 'overlay-custom-class-name',
    //           buttons: [
    //             {
    //               label: 'Yes',
    //               onClick: () => {
    //                 const postData = {
    //                   id: cell.row.id,
    //                   inactive: true,
    //                 }

    //                 axios
    //                   .post(`${process.env.REACT_APP_API_URL}/Diagnosis/AddDiagnosis`, postData, {
    //                     headers
    //                   })
    //                   .then(response => {
    //                     setRefresh(!refresh)
    //                     // setOpenNote(false)
    //                     // console.log('response.data: ', response.data)
    //                   })
    //                   .catch(error => {
    //                     console.error('There was an error!', error)
    //                   })
    //               }
    //             },
    //             {
    //               label: 'No'
    //             }
    //           ]
    //         })
    //       }}
    //     ></DeleteIcon>
    //   )
    // }
  ]
  const style = {
    position: 'absolute',
    top: '54%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.5)',
    padding: '15px',
    borderRadius: '8px',
    maxHeight: '89vh',
    // overflow: 'auto',

  };
  const columnsresolve = [
    {
      field: 'id',
      headerName: 'ID',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.1
    },

    {
      field: 'patientName',
      headerName: 'Patient Name',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3,
      renderCell: (cellValues) => (
        <Button
          style={{ color: 'rgba(58, 53, 65, 0.87)', display: 'flex', justifyContent: 'flex-start' }}
          size="small"
          variant="text"
          color="info"
          onClick={() => handleRowClick2(cellValues)}
        >
          {cellValues.row.patientName}
        </Button>
      ),

    },
    {
      field: 'createdDate',
      headerName: 'Date',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3,
      valueGetter: (params) => {
        return moment(params.row.createdDate).format('MM-DD-YYYY');
      }
    },
    {
      field: 'subject',
      headerName: 'Subject',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.2
    },
    {
      field: 'comments',
      headerName: 'Comments',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.4
    },
    {
      field: 'assignedTo',
      headerName: 'To',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3
    },
    // {
    //   field: 'inactive',
    //   headerClassName: 'super-app-theme--header',
    //   headerName: '',
    //   sortable: true,
    //   flex: 0.2,
    //   // hide: true,
    //   // hide: Usertype == 'Admin'?false:true,

    //   renderCell: cell => (

    //     <>
    //       <RestartAltIcon
    //         style={{
    //           marginRight: '5px',
    //           float: 'right',
    //           // marginTop: '5px',
    //           color: 'red',
    //           cursor: 'pointer',
    //         }}
    //         color="black"
    //         onClick={() => {
    //           setDialogOpen(true)
    //           setDelbyid(cell.row.id)
    //           setPatientiidresolve(cell.row.patientId)
    //           setsubject(cell.row.subject)
    //           setassginedto(cell.row.assignedTo)
    //           setdate(cell.row.createdDate)
    //           setcomments(cell.row.comments)

    //         }}
    //       ></RestartAltIcon>

    //       <Dialog
    //         open={isDialogOpen}
    //         onClose={() => setDialogOpen(false)}
    //         aria-labelledby="delete-dialog-title"
    //         BackdropComponent={Backdrop}
    //         BackdropProps={{
    //           invisible: true,
    //         }}
    //         PaperProps={{
    //           style: {
    //             marginRight: '5px',
    //             float: 'right',
    //             marginTop: '5px',
    //             color: 'red',
    //             cursor: 'pointer',
    //           },
    //         }}
    //       >
    //         <div style={{
    //           display: 'flex',
    //           flexDirection: 'column',
    //           alignItems: 'center', // Center horizontally
    //           justifyContent: 'center', // Center vertically
    //           borderRadius: '8px',
    //           width: '500px'
    //         }}>

    //           <ErrorOutlineIcon style={{ fontSize: '100px', color: 'red' }} />
    //           <DialogTitle style={{ fontWeight: 'bold', color: 'black', fontSize: ' 1.25rem' }}>Are you sure?</DialogTitle>
    //           <h5 style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'normal', color: '#444444' }}>
    //             Reopen this Patient!
    //           </h5>
    //           <DialogContent>
    //             <DialogContentText>

    //               <Grid style={{ marginTop: '1rem' }}>
    //                 <Button onClick={() => setDialogOpen(false)} style={{ backgroundColor: '#6c7c84', color: 'white', marginBottom: '1rem' }}>No,cancel!</Button>
    //                 <Button onClick={() => handleDelete(cell)} style={{ backgroundColor: 'red', color: 'white', marginLeft: '1rem', marginBottom: '1rem', border: '1px solid #b4acec' }}>Yes,Reopen it!</Button>
    //               </Grid>
    //             </DialogContentText>
    //           </DialogContent>
    //         </div>

    //       </Dialog>
    //     </>
    //   )
    // }


  ]
  const ArchivedCol = [
    {
      field: 'id',
      headerName: 'ID',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.1
    },

    {
      field: 'patientName',
      headerName: 'Patient Name',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3,
      renderCell: (cellValues) => (
        <Button
          style={{ color: 'rgba(58, 53, 65, 0.87)', display: 'flex', justifyContent: 'flex-start' }}
          size="small"
          variant="text"
          color="info"
          onClick={() => handleRowClick2(cellValues)}
        >
          {cellValues.row.patientName}
        </Button>
      ),

    },
    {
      field: 'createdDate',
      headerName: 'Date',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3,
      valueGetter: (params) => {
        return moment(params.row.createdDate).format('MM-DD-YYYY');
      }
    },
    {
      field: 'subject',
      headerName: 'Subject',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.2
    },
    {
      field: 'comments',
      headerName: 'Comments',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.4
    },
    {
      field: 'assignedTo',
      headerName: 'From',
      cellClassName: 'gridCell',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.3
    },


  ]

  const [rows, setRows] = useState(null)
  const [rowsresolve, setRowsresolve] = useState(null)
  const [rowId, setRowID] = React.useState(0);

  useEffect(() => {
    setLoading(true)
    // POST request using axios inside useEffect React hook
    axios
      .get(`${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=${'all'}&patientId=${patientid}`, { headers })
      .then(response => {
        setLoading(false)
        setRows(response)
      })

      .catch(error => { })

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [refresh, value])

  useEffect(() => {
    setLoading(true)
    // POST request using axios inside useEffect React hook
    axios
      .get(`${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=${'sent'}&patientId=${patientid}`, { headers })
      .then(response => {
        setLoading(false)
        setRowsresolve(response)
      })
      .catch(error => { })

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [refresh, value])
  const [Archieved, setArchieved] = useState(null)

  useEffect(() => {
    setLoading(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}/Notifications/getNotifications?messageType=${'archive'}&resolved=${true}&patientId=${patientid}`, { headers })
      .then(response => {
        setLoading(false)
        setArchieved(response)
      })
      .catch(error => { })

  }, [refresh, value])

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    fields.forEach((field) => setValue(field, ''));
  };

  const onSubmit = data => {

    const postData = { ...data };
    postData.id = rowId;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Notifications/addNotifications`,
        postData,
        { headers }
      )
      .then(response => {
        if (response.id > 0) {
          // setSubmitting(false);

          alert.success("Record saved successfully.", {
            type: "success",
            onClose: () => {
              setOpenModal(false)
            }
          });
        }
      })
      .catch(error => {
        // setSubmitting(false);
        alert.error(`Error ${error.message}`, {
          type: "error"
        });
      });
  };
  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseImage = () => {
    setModalOpen(false);
  };
  const [DocNameee, setDocNameee] = useState('')
  const [fileUrl, setFileUrl] = useState('');

  const handleViewClick = (fileUrl, documentName) => {
    var arr = documentName.split('.');
    setDocNameee(arr.length > 1 ? arr[1].toLowerCase() : '');

    axios
      .get(`${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${fileUrl}`, { headers })
      .then((response) => {
        setFileUrl(response);
        setModalOpen(true);
        var arr = documentName.split('.');
        setDocNameee(arr.length > 1 ? arr[1].toLowerCase() : '');
      })
      .catch(error => {
        console.error('There was an error!', error);
      });
  };
  const [NewNotification, setNewNotification] = useState(false)
  const [DisAble, setDisAble]=useState(false)

  const HanldeOpenNewNotification = () => {
    setNewNotification(true)
  
  }
  const [Subject, setSubject] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [Comments, setComments] = useState("");
  const [practicesList, setpracticesList] = useState([]);
   const [NotifcationData,setNotifcationData]=useState('')
  const HanldeOpenEditNotification = (row) => {
    setNewNotification(true)
    setNotifcationData(row)
    setSubject(row.subject);
    setAssignedTo(row.assignedTo);
    setDisAble(true)
    setCreatedDate(row.createdDate)
  }
  const PatientName = props.PatientName

  const HandleCloseNewNotification = () => {
    setNewNotification(false);
    setSubject("");
    setDisAble(false)
    setCreatedDate("");
    setAssignedTo("");
    setComments("");
    setAssignedToError(false);
    setcolumnID(0)
    setNotifcationData('')
    setShowStatement(false)
  };



  const practicesListid = localStorage.getItem('default_paractice')
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/UserPractices/users?tokenPracticeId=${practicesListid}&showAllPractices=${true}`, {
        headers
      })
      .then(response => {
        var prac = [];
        response.forEach(field => {
          prac.push({
            label: `${field.fullName}<${field.email}>`,
            value: field.email
          });
        });
        setpracticesList(prac);

      })
      .catch(error => { });
  }, []);
  const [subjectError, setSubjectError] = useState(false);
  const [assignedToError, setAssignedToError] = useState(false);
  const [TmdId, setcolumnID] = useState(0)
  const [CreatedBy, setCreatedBy] = useState('')
 const [ShowStatement,setShowStatement] = useState(false)
  const handleSubmitMessgae = async () => {
    let isValid = true;
    if (!Subject.trim()) {
      setSubjectError(true);
      isValid = false;
    } else {
      setSubjectError(false);
    }

    if (!assignedTo) {
      setAssignedToError(true);
      isValid = false;
    } else {
      setAssignedToError(false);
    }

    if (!isValid) {
      return; // Stop execution if validation fails
    }
    const postData = {
      patientName: PatientName,
      subject: Subject,
      createdDate: createdDate,
      // assignedTo:NotifcationData ? NotifcationData.createdBy :assignedTo,
      assignedTo:assignedTo,
      comments: Comments,
      patientId: patientid,
      createdBy:NotifcationData ? NotifcationData.createdBy : CreatedBy,
      id: TmdId,
     parentId : NotifcationData.parentId ? NotifcationData.parentId : NotifcationData.id

    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Notifications/AddNotifications`,
        postData,
        { headers }
      );

      // Swal.fire({
      //   title: "Success!",
      //   text: "Notification added successfully",
      //   icon: "success",
      //   confirmButtonText: "OK",
      // });
      Swal.fire({
        title: "Success!",
        text: "Notification added successfully",
        icon: "success",
        confirmButtonText: "OK",
        willOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) {
            swalContainer.style.zIndex = '1800';
          }
        }
      });
      HandleCloseNewNotification();

    } catch (error) {
      // Swal.fire({
      //   title: "Error!",
      //   text: "Failed to add notification. Please try again.",
      //   icon: "error",
      //   confirmButtonText: "OK",
      // });
      Swal.fire({
        title: "Error!",
        text: "Failed to add notification. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
        willOpen: () => {
          const container = document.querySelector('.swal2-container');
          if (container) {
            container.style.zIndex = '1800'; // Inline z-index
          }
        }
      });
    }
  };


  const [openDocument, setOpenDocument] = React.useState(false);
  const handleCloseDocument = () => { setOpenDocument(false) }
  const checkstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 500,
    padding: '20px',
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,

  };
  return (
    <div >
      <Modal
        id="hello-world"
        open={openDocument}
        sx={{ zIndex: 1760 }}
        onClose={handleCloseDocument}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        visible={true} title={'Title'} footer={'Footer'}
      >
        <Box sx={checkstyle}>

          <Grid container spacing={1} style={{
            background: '#377562',
            position: 'sticky',
            marginBottom: '14px',
            padding: '8px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(54, 118, 196, 0.5)',
            display: 'flex'
          }} >
            <Grid item xs={11} >
              <Typography style={{
                fontSize: '17px',
                fontWeight: 'bold',
                marginLeft: '5px',
                color: '#fff'
              }}>Add Patient Document </Typography>
            </Grid>
            <Grid item xs={1} style={{ fontWeight: 500, }}>

              <CancelOutlinedIcon
                onClick={handleCloseDocument}
                fontSize="medium"
                style={{
                  color: "red",
                  cursor: 'pointer',
                  float: 'right',
                }}
              ></CancelOutlinedIcon>

            </Grid>

          </Grid>
          <Grid item xs={12}>
            <Documents callingFrom={"notifcation"}
              updateNotificaton={(id, _notifcationId, createdBy) => {
                setValue('id', _notifcationId)
                setcolumnID(_notifcationId)
                setCreatedBy(createdBy)
                setShowStatement(true)
                console.log(_notifcationId, 'This is Notification Id')

              }}

              patientid={patientid}
              AuthorizationFormByCPTid={TmdId} handleCloseNotification={handleCloseDocument}
            ></Documents>
          </Grid>


        </Box>
      </Modal>
      <Modal
        open={openModal}
        sx={{ zIndex: 1760 }}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            container xs={12}
            style={{
              background: '#377562',
              position: 'sticky',
              marginBottom: '14px',
              padding: '8px',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(54, 118, 196, 0.5)',
              display: 'flex'
            }}
          >
            <Grid item xs={11}>
              <Typography style={{
                fontSize: '17px',
                fontWeight: 'bold',
                marginLeft: '5px',
                color: '#fff'
              }}>Notification </Typography>
            </Grid>
            <Grid item xs={1}>
              <CancelOutlinedIcon
                onClick={handleCloseModal}
                fontSize="medium"
                color="red"
                style={{
                  color: 'red',
                  cursor: 'pointer',
                  float: 'right',
                }}
              ></CancelOutlinedIcon>
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{
            padding: '5px',
            maxHeight: '57vh',
            overflowY: 'auto',
            marginTop: '4px',
            scrollbarWidth: 'thin', // For Firefox
            scrollbarColor: '#3676c4 transparent', // thumb color and track color
            '&::-webkit-scrollbar': {
              width: 8, /* Width of vertical scrollbar */
              height: 8, /* Height of horizontal scrollbar */
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#3676c4', /* Color of the thumb */
              borderRadius: 10,
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent', /* Color of the track */
            },
            /* Adjust the width for the horizontal scrollbar */
            '&::-webkit-scrollbar-thumb:horizontal': {
              width: 4, /* Width of horizontal scrollbar */
            },
          }}>


            <Grid container spacing={2} style={{ paddingLeft: '40px' }}>

              {selectedRow != null && selectedRow?.length > 0
                ? selectedRow.map((row, index) => {
                  const documentParts = row.fileUrl?.split('@@');
                  return (
                    <Paper
                      key={index}
                      variant="outlined"
                      square
                      style={{
                        backgroundColor: '#F0F6F8',
                        borderRadius: '15px',
                        marginTop: '14px',
                        borderColor: '#377562',
                        maxWidth: '100%',
                        padding: '.9rem',
                        marginLeft: '0 .2rem',
                      }}
                    >


                      <Grid container spacing={2} item xs={12} sm={12} xl={12}>
                        <Grid container>
                          <Grid item xs={3}>
                            <Typography style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '20px' }}>
                              Patient Name:
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <Typography style={{ fontSize: '14px' }}>{row.patientName}</Typography>
                          </Grid>

                          <Grid item xs={3}>
                            <Typography style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '20px' }}>
                              Subject:
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <Typography style={{ fontSize: '14px' }}>{row.subject}</Typography>
                          </Grid>

                          <Grid item xs={3}>
                            <Typography style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '20px' }}>
                              Comments:
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <Typography style={{ fontSize: '14px' }}>{row.comments}</Typography>
                          </Grid>

                          <Grid item xs={3}>
                            <Typography style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '20px' }}>
                              Assigned To:
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <Typography style={{ fontSize: '14px' }}>{row.assignedTo}</Typography>
                          </Grid>

                          <Grid item xs={3}>
                            <Typography style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '20px' }}>
                              Date:
                            </Typography>
                          </Grid>
                          <Grid item xs={5}>
                            <Typography style={{ fontSize: '14px' }}>
                              {moment(row.createdDate).format('DD-MM-YYYY')}</Typography>
                          </Grid>
                          <Grid item xs={11} style={{ fontWeight: 500 }}>
                            {row.fileUrl?.length > 0 && (
                              <a
                                href="#"
                                style={{
                                  fontSize: '13px',
                                  marginBottom: '3px',
                                  marginLeft: '25px',
                                  borderBottom: '1px solid black',
                                  maxWidth: '100%',
                                  wordWrap: 'break-word',
                                  whiteSpace: 'pre-wrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'block',
                                }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent the default behavior of anchor tag (i.e., navigating to another page)
                                  setopendocs(true);
                                  var url = row.fileUrl?.slice('@@');
                                  const splitDocuments = row.fileUrl?.split('@@');
                                  const desiredText = splitDocuments[1];
                                  const pathurl = row.fileUrl;
                                  seturldownload(desiredText);
                                  axios
                                    .get(`${process.env.REACT_APP_API_URL}/PatientDocument/ViewPatientDocument?path=${pathurl}`, {
                                      headers
                                    })
                                    .then(response => {
                                      seturlFile(response);
                                    })
                                    .catch(error => {
                                      console.error('There was an error!', error);
                                    });
                                  setFullDocName(documentParts);
                                }}
                              >
                                {/* {completed ? 'Resolve' : 'Resolved'} */}
                                {/* {documentParts?.length > 0 ? documentParts[0] : ''} */}
                            {row.documentName}
                              </a>

                            )}

                            {/* <Typography style={{ fontSize: '14px' }}>{documentParts?.length>0?documentParts[0]:''}</Typography> */}
                          </Grid>
                          <Grid item xs={8} style={{ fontWeight: 500}}></Grid>

                          <Grid item xs={4} style={{ fontWeight: 500, alignContent: 'right' }}>

                            <Button className="Button" onClick={() => HanldeOpenEditNotification(row)}
                              variant='contained'>
                              <AddOutlinedIcon
                                fontSize='small'
                                style={{
                                  color: 'white',
                                  paddingRight: '4px',
                                  paddingBottom: '2px',

                                }}
                              ></AddOutlinedIcon>
                              Open and Reply
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                })
                : 'No Record Found'}


            </Grid>
            {/* <Grid container spacing={2} style={{ paddingLeft: '40px' }}>
              {ImageData != null && ImageData.length > 0 ? (
                ImageData.map((row, index) => (
                  <Paper
                    variant="outlined"
                    square
                    style={{
                      backgroundColor: '#F0F6F8',
                      borderRadius: '15px',
                      marginTop: '19px',
                      borderColor: '#377562',
                      maxWidth: '100%',
                      padding: '.9rem',
                      width: '590px',
                      marginBottom: '1rem',
                      marginLeft: '0 .2rem',
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} style={{ marginTop: '20px', borderRadius: '8px' }}>
                        <Typography
                          variant='h6'
                          component='h2'
                          style={{ fontWeight: 400, backgroundColor: '#377562', marginBottom: 5, color: '#fff', borderRadius: '8px' }}
                        >
                          {row.documentName}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} style={{ fontWeight: 500, marginBottom: '25px' }}>

                        <Button
                          className='Button'
                          variant='gradient'
                          onClick={() => handleViewClick(row.fileUrl, row.documentName)}
                          style={{
                            color: 'white',
                            fontSize: '13px',
                            height: '27px',
                            marginBottom: '3px',
                            float: 'right'
                          }}
                        >

                          View
                        </Button>
                      </Grid>


                    </Grid>

                  </Paper>
                ))
              ) : (
                <Typography style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '15px' }}>
                  No Images Found
                </Typography>
              )}

            </Grid> */}


          </Grid>
        </Box>
      </Modal>
      <Modal
        open={NewNotification}
        onClose={HandleCloseNewNotification}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 1760 }}
      >
        <Box sx={style}>
          <Grid
            container xs={12}
            style={{
              background: '#377562',
              position: 'sticky',
              marginBottom: '14px',
              padding: '8px',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(54, 118, 196, 0.5)',
              display: 'flex'
            }}
          >
            <Grid item xs={11}>
              <Typography style={{
                fontSize: '17px',
                fontWeight: 'bold',
                marginLeft: '5px',
                color: '#fff'
              }}> Create New Messages </Typography>
            </Grid>
            <Grid item xs={1}>
              <CancelOutlinedIcon
                onClick={HandleCloseNewNotification}
                fontSize="medium"
                color="red"
                style={{
                  color: 'red',
                  cursor: 'pointer',
                  float: 'right',
                }}
              ></CancelOutlinedIcon>
            </Grid>
          </Grid>
          <Grid container spacing={2} padding={2} sx={{
            height: "400px", // Set a fixed height
            overflowY: "auto", // Enable vertical scrolling
            overflowX: "hidden", // Hide horizontal scrolling if not needed
          }}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%' }}>
                <Button
                  onClick={() => setOpenDocument(true)}
                  className="Button"
                  variant="gradient"
                  color="info"
                  size="small"
                  style={{
                    width: '200px',
                    height: '33px',
                    color: 'white',
                    fontSize: '14px',
                  }}
                >
                  <AddOutlinedIcon
                    fontSize="medium"
                    style={{
                      color: 'white',
                      paddingRight: '4px',
                      paddingBottom: '2px',
                    }}
                  />
                  Add Document
                </Button>
                {ShowStatement && (
                  <span
                    style={{
                      marginTop: '8px',
                      color: 'green',
                      fontWeight: 500,
                      fontSize: '14px',
                      width: '100%',
                      textAlign: 'right',
                    }}
                  >
                    ✅ Your document has been submitted.
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={6}>
              <InputLabel>Patient's Last Name</InputLabel>
              <TextField size="small" fullWidth value={PatientName} />
            </Grid>
            <Grid item xs={6}>
              <InputLabel>Subject</InputLabel>

              <TextField
                value={Subject}
                size="small"
                // onChange={(e) => setSubject(e.target.value)}
                InputProps={{ readOnly: DisAble }}
                onChange={(e) => {
                  setSubject(e.target.value);
                  setSubjectError(false);
                }}
                placeholder="Please enter Subject"
                fullWidth
                error={subjectError}
                helperText={subjectError ? "Subject is required" : ""}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel>Created Date</InputLabel>

              <TextField
                value={createdDate}
                onChange={(e) => setCreatedDate(e.target.value)}
                type="date"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel>Assigned to</InputLabel>
              {/* {DisAble == false ? ( */}
              <ReactSelect
                fullWidth
               
                value={practicesList.find(option => option.value == assignedTo)}
                onChange={(e) => {
                  setAssignedTo(e.value);
                  setAssignedToError(false)
                }}
                options={practicesList}
              />
            {/* ) : (
              <TextField
                value={NotifcationData.assignedTo}
                InputProps={{ readOnly: DisAble }}
                size='small'
                fullWidth
              />
            )} */}
            {assignedToError && <p style={{ color: "red", fontSize: "14px" }}>Please Select User</p>}
            </Grid>
            <Grid item xs={12}>
              <InputLabel>Comments</InputLabel>

              <TextField
                value={Comments}
                onChange={(e) => setComments(e.target.value)}
                placeholder="Please enter Comments"
                multiline
                row={2}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}></Grid>
            <Grid item xs={3}>
              <Button className='Button' fullWidth variant='contained' style={{
                float: 'right',
                // width: '250px',
                height: '35px',
                marginTop: '25px',
                fontSize: '14px',
                color: 'white',
                // backgroundColor:'#004cab'
              }} onClick={handleSubmitMessgae}>Send</Button></Grid>
            <Grid item xs={3}>
              <Button
                fullWidth
                variant='contained' style={{
                  float: 'right',
                  // width: '250px',
                  height: '35px',
                  marginTop: '25px',
                  fontSize: '14px',
                  color: 'white',
                  // backgroundColor:'#004cab'
                }} className='Button' onClick={HandleCloseNewNotification} >Cancel</Button></Grid>
          </Grid>


        </Box>
      </Modal>
      <Modal
        open={modalOpen}
        onClose={handleCloseImage}
        sx={{ zIndex: 1760 }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '52%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 912,
            bgcolor: 'background.paper',
            // border: '2px solid #000',
            borderColor: '#326C1D',
            border: 5,
            padding: '5px',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* <div>

            <iframe
              // height='500'
              // width='530px'
              border='4px solid #000'
              height='500px'
              width='875px'
              src={`${imageee}`}
            ></iframe>

          </div> */}
          <div>
            {(DocNameee === 'jpg' || DocNameee === 'jpeg' || DocNameee === 'png') ? (
              <>

                <Grid item xs={8}>
                  <img
                    height='400px'
                    width='850px'
                    style={{ border: '4px solid #000' }}
                    src={`${fileUrl}`}
                    alt='Document'
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </>
            ) : (
              <>
                <Grid item xs={12}>
                  <iframe
                    height='400px'
                    width='850px'
                    style={{ border: '4px solid #000' }}
                    src={`${fileUrl}`}
                  ></iframe>
                </Grid>
              </>
            )}
          </div>
          <Grid item xs={2} style={{ fontWeight: 500, marginLeft: '30px', marginBottom: '25px', marginTop: '10px' }}>

            <Button
              className='Button'
              variant='gradient'
              onClick={handleCloseImage}
              style={{
                color: 'white',
                fontSize: '13px',
                height: '27px',
                marginBottom: '3px',
                float: 'right'
              }}
            >

              Close
            </Button>
          </Grid>

        </Box>
      </Modal>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Button className="Button" onClick={HanldeOpenNewNotification} variant='contained'>
            <AddOutlinedIcon
              fontSize='small'
              style={{
                color: 'white',
                paddingRight: '4px',
                paddingBottom: '2px',

              }}
            ></AddOutlinedIcon>
            Add New Messages
          </Button>
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="lab API tabs example"
          >
            <Tab value={0} label="Inbox" />
            <Tab value={1} label="Sent" />
            {/* {UserType != 'Front Office' ? ( */}

            <Tab value={2} label="Archieved" />
            {/* )  : null} */}




          </TabList>
        </Box>
        <TabPanel value={0}>
          <Box mb={3} marginTop={2}>
            {isLoading ? (
              <div style={{ margin: '5rem', textAlign: 'center' }}>
                <CircularProgress />
              </div>
            ) : (
              <div style={{ height: 400, width: "100%" }}>
                {rows === null || rows.length === 0 ? (
                  <Typography>No Record found</Typography>
                ) : (
                  <DataGrid
                    rows={rows}
                    classes={gridClasses}
                    rowHeight={25}
                    columns={columns}
                    getRowSpacing={getRowSpacing}
                    //checkboxSelection
                    fullWidth
                    pagination
                    autoPageSize
                    sx={gridRowStyle}
                  />
                )}
              </div>
            )}
          </Box>
        </TabPanel>
        <TabPanel value={1}>
          <Box mb={3} marginTop={2}>
            {isLoading ? (
              <div style={{ margin: '5rem', textAlign: 'center' }}>
                <CircularProgress />
              </div>
            ) : (
              <div style={{ height: 400, width: "100%" }}>
                {rowsresolve === null || rowsresolve.length === 0 ? (
                  <Typography>No Record found</Typography>
                ) : (
                  <DataGrid
                    rows={rowsresolve}
                    classes={gridClasses}
                    rowHeight={20}
                    columns={columnsresolve}
                    getRowSpacing={getRowSpacing}
                    //checkboxSelection
                    fullWidth
                    pagination
                    autoPageSize
                    sx={gridRowStyle}
                  />
                )}
              </div>
            )}
          </Box>

        </TabPanel>
        <TabPanel value={2}>
          <Box mb={3} marginTop={2}>
            {isLoading ? (
              <div style={{ margin: '5rem', textAlign: 'center' }}>
                <CircularProgress />
              </div>
            ) : (
              <div style={{ height: 400, width: "100%" }}>
                {Archieved === null || Archieved.length === 0 ? (
                  <Typography>No Record found</Typography>
                ) : (
                  <DataGrid
                    rows={Archieved}
                    classes={gridClasses}
                    rowHeight={20}
                    columns={ArchivedCol}
                    getRowSpacing={getRowSpacing}
                    //checkboxSelection
                    fullWidth
                    pagination
                    autoPageSize
                    sx={gridRowStyle}
                  />
                )}
              </div>
            )}
          </Box>

        </TabPanel>
      </TabContext>
      <Modal
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        onClose={() => setopendocs(false)}
        sx={{ zIndex: 1769 }}

        open={opendocs}
      >
        <Box sx={styleofmodal}>
          <Grid container>
            <Grid item xs={9}>
              <Typography id='modal-modal-title' variant='h6' component='h2' style={{ fontWeight: 500, backgroundColor: '#377562', marginBottom: 5, color: 'white' }}>
                {FullDocName[0]}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              {submitting ? (
                <LoadingButton
                  loading
                  loadingIndicator='Downloading'
                  color='primary'
                  variant='contained'
                >
                  Fetch data
                </LoadingButton>
              ) : (
                <Button
                  className="Button"
                  size='small'
                  startIcon={<Download />}
                  onClick={() => {
                    download(`${urldownload}`, FullDocName)
                  }}
                  variant='contained'
                  style={{
                    color: 'white',
                    float: 'right'
                  }}
                >
                  Download
                </Button>
              )}
            </Grid>
            <Grid item xs={1}>
              <CancelOutlinedIcon
                onClick={() => setopendocs(false)}
                fontSize='large'
                color='red'
                cursor='pointer'
                style={{ color: 'red', marginBottom: 5, float: 'right', }}
              ></CancelOutlinedIcon>

            </Grid>
            {(DocName && DocName == 'jpg') || DocName == 'png' || DocName == 'jpeg' ? (
              <>
                <Grid item xs={2}></Grid>
                <Grid item xs={8}>
                  <img
                    height='500px'
                    width='500px'
                    border='4px solid #000'
                    src={`${urlFile}`}
                  ></img>
                </Grid>
                <Grid item xs={2}></Grid>
              </>
            ) : (
              <>
                <Grid item xs={12}>
                  <iframe
                    height='500px'
                    width='875px'
                    src={`${urlFile}`}
                  ></iframe>
                </Grid>
              </>
            )}
            <Grid item xs={12}></Grid>
          </Grid>
        </Box>
      </Modal>


    </div>


  )
}

export default Notification
